import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import {useDispatch, useSelector} from "react-redux";
import {changeCrudSnackbar} from "./crudSnackbarSlice";



const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function CrudSnackbar() {

    const closeCrudSnackbar = useDispatch();

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        closeCrudSnackbar(changeCrudSnackbar({crudOpen: false, crudSeverity: "", crudMessage: ""}))
    };

    return (
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={useSelector((state) => state.crudSnackbarSlc.value.crudOpen)}
                      autoHideDuration={3000}
                transitionDuration={{ enter: 500, exit: 500 }}
                onClose={handleClose}
            >
                <Alert
                    onClose={handleClose}
                       severity={useSelector((state) => state.crudSnackbarSlc.value.crudSeverity)}
                    sx={{ width: '100%' }}>
                    {useSelector((state) => state.crudSnackbarSlc.value.crudMessage)}
                </Alert>
            </Snackbar>
    );
}
